import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
  import draggable from 'vuedraggable';
  import { CourseItem, CourseSection, CourseTree } from '@/entities/trainings';
  import { useCourseBuilderStore } from '@/stores/trainings/courseBuilder';
  import TreeToolbar from '@/ui/components/trainings/courseBuilder/TreeToolbar.vue';
  import { Icon } from '@/ui/components/icon/Icon';
  import { isSection } from '@/ui/helpers/trainingsHelper';

  
  // This is crazy, but let me explain:
  // this component is recursive,
  // recursive components require name, otherwise it won't work,
  // you cannot define name in composition API before Vue 3.3 where they added "defineOptions",
  // so the only workaround to define name in composition API before Vue 3.3 is to use <script> alongside <script setup>,
  // but 2 script tags trigger eslint "import/first", that's why it's disabled in <script setup>.
  const __default__ = {
    name: 'TreeItem',
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    item: {
      type: Object as () => CourseItem,
      required: true,
    },
    parent: {
      type: Object as () => CourseSection | CourseTree,
      required: true,
    },
  },
  setup(__props) {

const { item, parent } = __props;

  /* eslint-disable import/first */
  

  const collapsed = ref(false);

  const courseBuilderStore = useCourseBuilderStore();

  const isActive = (item: CourseItem): boolean => {
    return courseBuilderStore.activeItem === item;
  };

  const remove = (): void => {
    courseBuilderStore.removeItem(item, parent);
  };

  const toggle = (): void => {
    collapsed.value = !collapsed.value;
  };

  const onClick = (item: CourseItem): void => {
    if (!isSection(item)) {
      courseBuilderStore.setActiveItem(item);
    }
  };

return { __sfc: true,collapsed, courseBuilderStore, isActive, remove, toggle, onClick, draggable, TreeToolbar, Icon, isSection }
}

})